import { type FC } from 'react';
import { ProductAttributeInterface } from '../../../../../../../Interface/ProductAttribute';
import OverflowedTextTooltip from '../../../../../OverflowedTextTooltip/OverflowedTextTooltip';
import { FilterState } from '../../../../../../Context/ProductsFilterContext';
import styles from './AttributeBrandName.module.scss?module';
import Tooltip from '../../../../../Tooltip/Tooltip';
import clsx from 'clsx';
import useViewports from '../../../../../../Hooks/useViewports';
import PromoBadge from '../../../../Abstracts/PromoBadge/PromoBadge';
import { getFlavourDiscount } from '../../../../../../Helper/flavourDiscount';

type AttributeBrandNamePropsT = {
  attribute: ProductAttributeInterface;
  view: FilterState['view'];
  isNew?: boolean;
};

const AttributeBrandName: FC<AttributeBrandNamePropsT> = ({
  attribute,
  view,
  isNew,
}) => {
  const { xs, sm, md } = useViewports();
  const isMobile = xs || sm || md;
  const discount = getFlavourDiscount(attribute);
  const isClearanceFlavour = discount.isClearance;

  return (
    <>
      {view === 'table' ? (
        <>
          <div className={styles.brandContainer}>
            {isNew && (
              <div>
                <Tooltip title="New Product" placement="top">
                  <div className={styles.newBadge}>NEW</div>
                </Tooltip>
              </div>
            )}
            <div className={clsx(styles.brandName, isNew && styles.isNew)}>
              <OverflowedTextTooltip
                text={attribute.product_size.product.brand.name}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="d-flex align-items-center justify-content-end justify-content-lg-start gap-2">
          <p className="m-0">{attribute.product_size.product.brand.name}</p>
          {isMobile && attribute.product_size?.is_ncw_product_size && (
            <a href={attribute.product_size.ncw_link ?? ''} className={styles.ncwBadge}>
              NCW
            </a>
          )}
          {isMobile && isClearanceFlavour ? (
            <Tooltip title={discount.tooltip} placement="top">
              <div className={styles.ClearanceBadge}>{discount.badgeLabel}</div>
            </Tooltip>
          ) : null}
          {isMobile &&
          !isClearanceFlavour &&
          (attribute.product_size.promo_percent > 0 ||
            attribute.product_size.promo_free_product_count > 0) ? (
            <PromoBadge
              productSize={attribute.product_size}
              hasStock={!!attribute.has_stock}
            />
          ) : null}
        </div>
      )}
    </>
  );
};

export default AttributeBrandName;
